import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  LayoutDashboard,
  Building2,
  Lightbulb,
  Palette,
  Menu,
} from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';
import { colors, getNeumorphicShadow, getNeumorphicInset } from '@/lib/designSystem';
import MobileMenu from './MobileMenu';

const navItems = [
  { path: '/dashboard', icon: LayoutDashboard, label: 'Dashboard' },
  { path: '/organizations', icon: Building2, label: 'Orgs' },
  { path: '/intelligence', icon: Lightbulb, label: 'Insights' },
  { path: '/themes', icon: Palette, label: 'Themes' },
];

const BottomNav = () => {
  const [showMenu, setShowMenu] = useState(false);
  const { theme } = useTheme();
  const currentColors = colors[theme];

  return (
    <>
      <motion.nav
        initial={{ y: 100 }}
        animate={{ y: 0 }}
        className="md:hidden fixed bottom-0 left-0 right-0 z-50"
        style={
          {
            background: currentColors.background,
            boxShadow: `0 -4px 20px ${currentColors.shadowDark}`,
            borderTop: `1px solid ${currentColors.border}`,
          }
        }
      >
        <div className="flex items-center justify-around px-2 py-3">
          {navItems.map((item) => (
            <NavLink key={item.path} to={item.path}>
              {({ isActive }) => (
                <motion.div
                  className="flex flex-col items-center gap-1 px-3 py-2 rounded-xl min-w-[60px]"
                  style={
                    {
                      background: isActive ? currentColors.cardBg : 'transparent',
                      boxShadow: isActive ? getNeumorphicInset(theme) : 'none',
                    }
                  }
                  whileTap={{ scale: 0.95 }}
                >
                  <item.icon
                    size={20}
                    style={
                      {
                        color: isActive ? currentColors.accentBlue : currentColors.textSecondary,
                      }
                    }
                  />
                  <span
                    className="text-xs font-medium"
                    style={
                      {
                        color: isActive ? currentColors.accentBlue : currentColors.textSecondary,
                      }
                    }
                  >
                    {item.label}
                  </span>
                </motion.div>
              )}
            </NavLink>
          ))}
          
          {/* More Button (restored) */}
          <motion.button
            onClick={() => setShowMenu(true)}
            className="flex flex-col items-center gap-1 px-3 py-2 rounded-xl min-w-[60px]"
            whileTap={{ scale: 0.95 }}
          >
            <Menu size={20} style={{ color: currentColors.textSecondary }} />
            <span className="text-xs font-medium" style={{ color: currentColors.textSecondary }}>
              More
            </span>
          </motion.button>
        </div>
      </motion.nav>

      <MobileMenu isOpen={showMenu} onClose={() => setShowMenu(false)} />
    </>
  );
};

export default BottomNav;
